module.exports = __webpack_public_path__ + "static/media/torch-1.3c4b4ff6.glb";